<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="d-flex m-3 justify-content-between">
        <p class="fw-bold" >
          تعریف اقدامات اساسی
        </p>
        <div>
          <div class="d-flex changer">
            <p style="padding-right: 1vw;">
              تعریف اقدامات اساسی
            </p>
            <router-link style="font-size: 1vw" to="/problem_analysis/Definition_of_basic_measures/SupportMeasures">
              تعریف اقدامات پشتیبان
            </router-link>
          </div>
        </div>
      </div>






      <Photographer/>







    </div>
  </div>
</template>


<script>
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import splash from "@/components/Splash/Splash.vue";
import SupportMeasures from "@/components/Definition_of_basic_measures/SupportMeasures.vue";
import Photographer from "@/components/Definition_of_basic_measures/Photographer.vue";
import router from "@/router";

export default {
  components: {
    Photographer,
    SupportMeasures,

    Sidebar,
    splash
  },
  methods:{
    checkIsMother(){
      if (this.is_mother){
        router.push('/mother_items')
        return
      }

    }
  },
  mounted() {
    this.checkIsMother()
  }

}
</script>
<style scoped lang="scss">
.changer{
  background-color: #AFAFAF;
  height: 2vw;
  border-radius: 1vw;
  width: 24vw;
  justify-content: space-evenly;
  &>p:nth-child(1){
    width: 11vw;
    height: 2vw;
    background-color: #3742FA;
    color: #fff;
    transform: translateX(.9vw);
    border-radius: 1vw;
  }
  &>p:nth-child(2){
    margin-left: 1vw;
  }  &>p {
       cursor: pointer;
       font-size: 1vw;
     }
  &>a{
    color: black;
    text-decoration: none;
    margin-left: .9vw;
  }
}
p {
  font-size: 1vw;
}
</style>